// VISINVOKE — DCC desktop sign-in bridge through the EXISTING staff login + MFA ceremony.
//
// When /v1/desktop/authorize bounces a STAFF account here (because the desktop session must carry
// MFA-verified staff authority), it appends ?redirect=<approved VISINVOKE authorize URL>. We persist that
// return URL at the start of the staff flow and resume it — with a full-page navigation back to /authorize —
// once the staff session is fully established (the admin dashboard mounts), so the DCC handoff completes
// with staff MFA verified. This adds NO new auth system and does NOT change staff login/MFA semantics: it
// only threads a validated return URL, mirroring the proven Login.js customer bridge allowlist.
const REDIRECT_HOST_ALLOWLIST = ['api.visinvoke.com', 'app.visinvoke.com', 'visinvoke.com', 'www.visinvoke.com'];
const KEY = 'scc_desktop_redirect';

export function safeExternalRedirect(raw) {
  if (!raw) return null;
  let u;
  try { u = new URL(raw); } catch { return null; }          // relative/internal -> not an external bridge
  if (u.protocol !== 'https:') return null;
  if (!REDIRECT_HOST_ALLOWLIST.includes(u.hostname.toLowerCase())) return null;
  return u.toString();
}

// Persist the approved return URL from the current location's ?redirect. `search` is injectable for tests.
export function captureDesktopRedirect(search) {
  try {
    const qs = search != null ? search : (typeof window !== 'undefined' ? window.location.search : '');
    const safe = safeExternalRedirect(new URLSearchParams(qs).get('redirect'));
    if (safe && typeof window !== 'undefined') window.sessionStorage.setItem(KEY, safe);
    return safe;
  } catch { return null; }
}

// Read + clear the persisted return URL, re-validating on the way out (never an open redirect).
export function consumeDesktopRedirect() {
  try {
    if (typeof window === 'undefined') return null;
    const v = window.sessionStorage.getItem(KEY);
    if (v) window.sessionStorage.removeItem(KEY);
    return safeExternalRedirect(v);
  } catch { return null; }
}
